import { render, staticRenderFns } from "./DeleteCustomerModal.vue?vue&type=template&id=46990c78&"
import script from "./DeleteCustomerModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports